module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/focus--customer-satisfaction.adb35e1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/focus--customer-satisfaction.pdf
// module id = 88Hs
// module chunks = 10